module.exports = __webpack_public_path__ + "pr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/pr.svg
// module id = 1021
// module chunks = 0